module.exports = __webpack_public_path__ + "img/user.b47eee0b.jpg";